const Banner = {
  init: function () {
    new Swiper(".bannerSwiper", {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".banner-swiper-button-next",
        prevEl: ".banner-swiper-button-prev",
      },
      pagination: {
        el: ".bannerSwiper .swiper-pagination",
        clickable: true,
      },
    });
  },
};

$(function () {
  Banner.init();
});
